// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"31829179","845":"6ea7e328","884":"fba85ce4","898":"3353f817","941":"5bde4de9"}[chunkId] + ".chunk.js";
};